<template>
  <v-container grid-list-md style="width: 80%;">
    <h2 class="mt-3 intro">Original piano music, from a small business.</h2>
    <v-layout row wrap justify-center>
      <v-flex md12 class="mt-2 ma-3 mb-0">
        <p class="intro-desc">Sonive Publishing offers you new piano music written by living composers; the music you find here is unique, and independent.</p>
        <div justify-center style="text-align: center;">
          <v-btn to="music/" color="info">View our music</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <v-layout row wrap justify-center>
      <v-flex class="signupHolder">
        <v-container>
          <div class="mt-3 mb-2 newInfoHeader">UPDATE</div>

          <v-spacer></v-spacer>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-flex md12>
            <div class="signupInfo mt-2 display-1 mx-4 bold mt-3 text-center">Now publishing classical favorites!</div>
            <div class="newInfoSubtitle mt-4">including</div>

            <div class="container">
              <div class="row" style="display: inline;">
                  <div class="col-xs-3">
                    <MusicHighlight :image="require('../assets/3-gymn/front cover 1.7.jpg')" target-path="music/3-Gymnopedies" title='3 Gymnopédies'></MusicHighlight>
                  </div>
                  <div class="col-xs-3">
                    <MusicHighlight :image="require('../assets/clair-de-lune//cover 1.3 first page.jpg')" target-path="music/Clair-de-Lune" title='Clair de Lune'></MusicHighlight>
                  </div>
              </div>
          </div>
          </v-flex>

        </v-container>
      </v-flex>
    </v-layout>
    <v-spacer class="ma-5"></v-spacer>
    <h2>A unique musical experience.</h2>
    <p
      class="mt-2 mb-5 ma-3"
    >We are currently just starting out, but with your support we hope to start a new wave of composition!</p>
  </v-container>
</template>

<script>
import MusicHighlight from './Home/MusicHighlight.vue';
export default {
  components: { MusicHighlight },
  name: "Home",
  data: () => ({}),
  head: {
    title: {
      inner: "Sonive Publishing",
      separator: "-",
      complement: "Home"
    },
    meta: [
      {
        name: "description",
        content:
          "Classical music for the 21st century. Publishing compositions that engage in historical and modern styles."
      }
    ]
  },
  methods: {
    showModal(isOn) {
      this.$parent.$parent.$parent.showModal(isOn);
    }
  }
};
</script>

<style>
.intro {
  font-size: 24px;
}

.intro-desc {
  font-size: 16px;
}

h2 {
  font-size: 32px;
}

p {
  font-size: 20px;
}

.musicPreviewText {
  font-size: 14px;
  font-weight: bold;
}

.menuImageText {
  font-size: 24px;
  color: white;
  font-weight: 300;
  font-family: "Open Sans";
}

.bookInfoSubtitle {
  font-size: 30px;
  font-weight: 100;
}

.imageButton:hover {
  color: rgb(5, 226, 255);
}

.newInfoHeader {
  font-weight: 100;
  font-size: 28px;
}

.newInfoSubtitle {
  font-size: 16px;
  font-weight: bold;
}

.netInfoAuthor {
  font-size: 14px;
}

.imageButton {
  width: 100%;
  height: 20%;
  background-color: rgba(146, 122, 122, 0.15) !important;
}

.signupInfo {
  text-align: center;
  font-size: 18px;
}

.signupHolder {
  text-align: center;
}
</style>